<template>
    <div>
        <div class="Form__group">
            <label for="make" class="Form__label">Make</label>
            <multiselect v-model="make"
                         :options="makes"
                         trackBy="id"
                         label="name"
                         id="make"
                         placeholder="Select Model"
            >
            </multiselect>
        </div>

        <div class="Form__group" v-show="make">
            <label for="partial_vin" class="Form__label">Partial VIN (last 6 characters)</label>
            <input type="text"
                   name="partial_vin"
                   id="partial_vin"
                   class="Form__text"
                   v-model="partial_vin"
                   maxlength="6"
            >
            <div class="Form__error" v-show="showError">
                The partial VIN field must be 6 characters long
            </div>
        </div>

        <div class="Form__group" v-show="make">
            <a href="#" class="Button" @click.prevent="loadMatches">Search</a>
        </div>

        <table class="Table" v-show="hasMatches">
            <tr>
                <th style="width: 0">VIN</th>
                <th style="width: 0">Model Variant</th>
                <th style="width: 0">CO<sub>2</sub> (g/km)</th>
                <th style="width: 0">Engine Capacity</th>
                <th>Engines</th>
            </tr>
            <tr v-for="(model, index) in matches">
                <td>{{ model.vin }}</td>
                <td>{{ model.name }}</td>
                <td>{{ model.co2_combined }}</td>
                <td>{{ model.engine_cc }}</td>
                <td class="Table__cell--min-width" style="width: 50%;">
                    <form action="/wltp/download" method="POST" @submit.prevent="download($event)">
                        <input name="_token" type="hidden" :value="csrfToken">
                        <input type="hidden" name="vehicle_id" :value="model.id">

                        <div style="display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: nowrap">
                            <div style="margin-right: 10px; width: 100%;">
                                <label style="margin-bottom: 3px; display: block;">Engine Type</label>
                                <div class="Form__select">
                                    <select name="engine_type"
                                            :data-index="index"
                                            class="engine-type"
                                    >
                                        <option value="">Please Select</option>
                                        <option value="internal-combustion">Internal Combustion</option>
                                        <option value="hybrid">Hybrid</option>
                                        <option value="electric">Electric</option>
                                    </select>
                                </div>
                            </div>

                            <div class="ice-engine"
                                 style="margin-right: 10px; width: 100%; display: none;"
                                 :data-index="index"

                            >
                                <label style="margin-bottom: 3px; display: block;">Internal Combustion Engine</label>
                                <div class="Form__select">
                                    <select name="internal_combustion_engine_type"
                                            :data-index="index"
                                    >
                                        <option value="">Please Select</option>
                                        <option :value="type.id" v-for="type in iceEngines">{{ type.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="electric-engine"
                                 style="margin-right: 10px; width: 100%; display: none;"
                                 :data-index="index"
                            >
                                <label style="margin-bottom: 3px; display: block;">Electric Engine</label>

                                <div class="Form__select">
                                    <select name="electric_engine_type"
                                            :data-index="index"
                                    >
                                        <option value="">Please Select</option>
                                        <option :value="type.id" v-for="type in electricEngines">{{ type.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <input type="submit" value="Download Label" class="Button">
                        </div>
                    </form>
                </td>
            </tr>
            <tr v-if="! matchesFound">
                <td colspan="5" align="center">
                    <em>No Matches Found</em>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
        data() {
            return {
                csrfToken: Laravel.csrfToken,
                make: '',
                partial_vin: '',
                matches: null,
                showError: false,
            }
        },

        props: ['makes', 'iceEngines', 'electricEngines'],

        watch: {
            make(value) {
                if (! value) {
                    this.partial_vin = '';
                }
            }
        },

        computed: {
            hasMatches() {
                return _.isArray(this.matches);
            },

            matchesFound() {
                return ! _.isEmpty(this.matches);
            }
        },

        methods: {
            loadMatches() {
                if (this.partial_vin.length !== 6) {
                    this.showError = true;
                }

                this.$http.post('/wltp/matches', { make: this.make.id, partial_vin: this.partial_vin }).then((response) => {
                    this.matches = response.data;

                    document.addEventListener('change', e => {
                        if (e.target.classList.contains('engine-type')) {
                            let node = e.target;
                            let index = node.getAttribute('data-index');
                            let iceEngine = document.querySelector(`.ice-engine[data-index="${index}"]`);
                            let electricEngine = document.querySelector(`.electric-engine[data-index="${index}"]`);

                            if (node.value == '') {
                                iceEngine.style.display = 'none';
                                electricEngine.style.display = 'none';
                            } else if (node.value == 'internal-combustion') {
                                iceEngine.style.display = 'block';
                                electricEngine.style.display = 'none';
                            } else if (node.value == 'hybrid') {
                                iceEngine.style.display = 'block';
                                electricEngine.style.display = 'block';
                            } else {
                                iceEngine.style.display = 'none';
                                electricEngine.style.display = 'block';
                            }
                        }
                    });
                })
            },

            download(e) {
                // if (e.target.querySelector('[name="fuel_type_id"]').value === '') {
                //     e.target.querySelector('.Form__select').classList.add('Form__select--has-error');
                //
                //     return false;
                // }
                //
                try {
                    ga('send', {hitType: 'event',eventCategory: 'WLTP CO2',eventAction: 'Click',eventLabel: 'Download Label'});
                } catch (e) {
                    console.log('MOCK GA EVENT');
                }

                e.target.querySelector('.Form__select').classList.remove('Form__select--has-error');
                e.target.submit();
            }
        },

        components: {
            Multiselect,
        }
    }
</script>